import { setError } from '@/actions/message';
import { logger } from '@/lib/default-logger';
import store from '@/redux/store';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

class BaseService {
  private readonly baseURL: string;
  private readonly instance: AxiosInstance;

  constructor(baseURL: string) {
    logger.log('baseURL', baseURL);
    this.baseURL = baseURL;

    this.instance = axios.create({
      baseURL: this.baseURL,
    });

    this.instance.interceptors.request.use(
      (config) => {
        // let token: string | null = null;
        let token: string | null = null;

        // Redux Store'dan Token'ı Al
        const reduxState: any = store.getState(); // RootState tipini burada kullan
        if (reduxState.auth?.token) {
          token = reduxState.auth.token;
        }

        logger.log('Token:', token);
        // Eğer Redux'ta yoksa LocalStorage'dan al
        if (!token) {
          const persistRoot = localStorage.getItem('persist:root');
          if (persistRoot) {
            try {
              const parsedRoot = JSON.parse(persistRoot);
              const parsedAuthData = JSON.parse(parsedRoot.auth);
              token = parsedAuthData?.token ?? null;
            } catch (error) {
              logger.error('Auth verisi ayrıştırılamadı:', error);
            }
          }
        }

        logger.log('Kullanılan Token:', token);

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  async get(endpoint: string, config?: AxiosRequestConfig) {
    try {
      logger.log('GET Request:', this.baseURL + endpoint, config);
      const response = await this.instance.get(endpoint, config);
      logger.log('GET Response:', response);
      return response;
    } catch (error: any) {
      store.dispatch(setError(error.response.data.message) as any);
    }
  }

  async post(endpoint: string, data: any, config?: AxiosRequestConfig) {
    try {
      logger.log('POST Request:', this.baseURL + endpoint, config);
      return await this.instance.post(this.baseURL + endpoint, data, config);
    } catch (error: any) {
      logger.log('POST Error:', error);
      store.dispatch(setError(error.response.data.message) as any);
    }
  }

  async patch(endpoint: string, data: any, config?: AxiosRequestConfig) {
    try {
      logger.debug('PATCH Request:', this.baseURL + endpoint, config);
      const response = await this.instance.patch(
        this.baseURL + endpoint,
        data,
        config
      );
      logger.debug(response);
      return response;
    } catch (error: any) {
      store.dispatch(setError(error.response.data.message) as any);
    }
  }

  async put(endpoint: string, data: any, config?: AxiosRequestConfig) {
    try {
      logger.debug('PUT Request:', this.baseURL + endpoint, data, config);
      return await this.instance.put(this.baseURL + endpoint, data, config);
    } catch (error: any) {
      store.dispatch(setError(error.response.data.message) as any);
    }
  }

  async delete(endpoint: string, config?: AxiosRequestConfig) {
    try {
      return await this.instance.delete(this.baseURL + endpoint, config);
    } catch (error: any) {
      store.dispatch(setError(error.response.data.message) as any);
    }
  }
}

export const apiClient = new BaseService(
  process.env.REACT_APP_API_BASE_URL ?? ''
);
